import React from 'react';
import PropTypes from 'prop-types';

const Master = ({
    isLandscape,
    options,
    onSelect,
    selectedOption,
    renderWrapper: Wrapper,
    renderButton: Button
}) => (
    <Wrapper isLandscape={isLandscape} onSelect={onSelect} selectedOption={selectedOption}>
        {options.map((option) => (
            <Button
                key={`button_${option.title}`}
                onPress={() => {
                    onSelect(option);
                }}
                isActive={option === selectedOption}
                title={option.title}
                isLandscape={isLandscape}
            />
        ))}
    </Wrapper>
);

Master.propTypes = {
    isLandscape: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string
        })
    ).isRequired,
    onSelect: PropTypes.func.isRequired,
    selectedOption: PropTypes.shape({
        title: PropTypes.string
    }).isRequired,
    renderWrapper: PropTypes.func.isRequired,
    renderButton: PropTypes.func.isRequired
};

export default Master;
